<template>

  <PreavvisiSospSolleciti />

</template>

<script>
import PreavvisiSospSolleciti from '../components/pratiche/PreavvisiSospSolleciti.vue'

export default {
  pageName: 'PreavvisiSospSolleciti',
  components: {
    PreavvisiSospSolleciti

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
